var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268.688,
    height: 244.917,
    viewBox: "0 0 268.688 244.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotation_icon",
    "data-name": "rotation icon",
    transform: "translate(-616 -143.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32134",
    "data-name": "Path 32134",
    d: "M127.37,4.629a15.852,15.852,0,0,0-22.39,0L87.954,21.654h0L48.343,61.265,31.317,78.291a15.85,15.85,0,0,0,0,22.39L170.923,240.288a15.851,15.851,0,0,0,22.39,0l73.664-73.663a15.85,15.85,0,0,0,0-22.391ZM263.026,162.674l-73.664,73.664a10.257,10.257,0,0,1-14.487,0L35.268,96.731a10.255,10.255,0,0,1,0-14.488l17.2-17.2c3.575,2.377,7.886,2.365,10.541-.292L91.444,36.318c2.654-2.655,2.667-6.966.29-10.541l17.2-17.2a10.253,10.253,0,0,1,14.488,0L263.026,148.187a10.256,10.256,0,0,1,0,14.488",
    transform: "translate(601.197 143.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32135",
    "data-name": "Path 32135",
    d: "M105.645,387.486a85.492,85.492,0,0,1-85.307-81.744h9.249a3.647,3.647,0,0,0,2.993-5.729L19.766,277.82a3.646,3.646,0,0,0-6.315,0L.489,300.273a3.646,3.646,0,0,0,3.158,5.469h9.4a92.79,92.79,0,0,0,92.6,89.035,3.646,3.646,0,1,0,0-7.291",
    transform: "translate(616 -9.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32136",
    "data-name": "Path 32136",
    d: "M466.753,98.124A3.647,3.647,0,0,0,463.6,96.3H454.2A92.791,92.791,0,0,0,361.6,7.266a3.646,3.646,0,0,0,0,7.292A85.491,85.491,0,0,1,446.9,96.3H437.67a3.646,3.646,0,0,0-3.157,5.469l12.962,22.453a3.646,3.646,0,0,0,6.315,0l12.963-22.453a3.645,3.645,0,0,0,0-3.646",
    transform: "translate(417.446 139.774)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotation);
export default __webpack_public_path__ + "static/media/rotation.c1d43ac718e95664fcd0ebd8a31027da.svg";
export { ForwardRef as ReactComponent };